<span
  class="relative inline-block"
  [class]="componentClass">
  <span class="sr-only"><ng-content></ng-content></span>
  <span
    aria-hidden="true"
    class="relative animate-aurora">
    <ng-content></ng-content>
  </span>
</span>
